export const copyToClipboard = (copyValue: string) => {
  const input = document.createElement('input');
  input.type = 'text';
  input.value = copyValue;

  document.body.appendChild(input);
  input.select();

  try {
    document.execCommand('copy');
  } catch (e) {
    console.error('Unable to copy to clipboard');
  }

  document.body.removeChild(input);
};
